

/* global angular */

const Moment = require('moment');
const _ = require('lodash');

// Used for adjusting times to the local time relative to the site location's timezone
const LOCAL_TIMEZONE_OFFSET = new Date().getTimezoneOffset();

/** @DataCaptureSelectorStore */
const DataCaptureSelectorStore = function (Flux, DataCaptureSelectorActions, APP_DISPATCHER_ID, $rootScope) {

  const DataCaptureStore = Flux.Store.get('DataCaptureStore');

  //Store init
  const DataCaptureSelectorStore = Flux.Store.create({
    name: 'DataCaptureSelectorStore',
    events: {
      Changed: true,
      Loaded: true
    }
  });

  //Null initial state
  DataCaptureSelectorStore.$state = {
    currentDate: null,
    currentDisplayDate: null,
    availableDataCaptures: [],
    availableDataCapturesByType: []
  };


  /**
   * Constructor function that binds to the interaction Flux.Action Signal from the component
   */
  DataCaptureSelectorStore.init = function () {

    const dispatcher = Flux.Dispatcher.get(APP_DISPATCHER_ID);

    dispatcher.register(DataCaptureSelectorActions.DateChanged, this._handleDateChanged.bind(this));
    // dispatcher.register(DataCaptureSelectorActions.DataCaptureLoaded, this._handleDatacaptureLoaded.bind(this));
    dispatcher.register(DataCaptureSelectorActions.NewestDatacapture, this._handleNewestDataCapture.bind(this));
    dispatcher.register(DataCaptureSelectorActions.PreviousDatacapture, this._handlePreviousDataCapture.bind(this));
    dispatcher.register(DataCaptureSelectorActions.NextDatacapture, this._handleNextDatacapture.bind(this));
    dispatcher.register(DataCaptureSelectorActions.DatacaptureSelected, this._handleDatacaptureSelected);

    $rootScope.$on('MAP_LOADED', _.debounce(this._handleDatacaptureLoaded.bind(this), 1200, {
      leading: true,
      trailing: false
    }));
  }.bind(this);

  this._handleDatacaptureLoaded = () => {

    DataCaptureSelectorStore.emit(DataCaptureSelectorStore.Events.Loaded);
  };

  /**
   * Sets the current state to the passed one, and signals the Changed state
   * @param {object} [state], a valid state for the store.
   */
  DataCaptureSelectorStore.setState = (state) => {

    angular.extend(DataCaptureSelectorStore.$state, state);
    DataCaptureSelectorStore.emit(DataCaptureSelectorStore.Events.Changed);
  };

  /**
   * Prepares the date to display as: "August 28, 2015"
   */
  DataCaptureSelectorStore._formatDate = (date) => {

    return Moment.utc(date).locale('en').format('MMMM Do, YYYY');
  };

  // Helpers


  /*
   * Compares two dates using its utc properties (year, month and date),
   * so the two dates should be in the same local timezone
   */
  DataCaptureSelectorStore.isSameDate = (dateA, dateB) => {

    const utcDateA = new Date(dateA);
    const utcDateB = new Date(dateB);
    return utcDateA.getUTCFullYear() === utcDateB.getUTCFullYear() &&
      utcDateA.getUTCMonth() === utcDateB.getUTCMonth() &&
      utcDateA.getUTCDate() === utcDateB.getUTCDate();
  };

  // Handlers //////////////////////////////////////////////////////////////////

  /**
  * Get the new datacaps for the date picker, sorts them and sets the state
  */
  this._handleDataCaptureStoreChage = () => {

    let currentDate;
    let currentDisplayDate;
    const availableDataCapturesByType = {};
    let orderedDataCaptures = DataCaptureStore.get('available');
    const currentDataCapture = DataCaptureStore.get('current');

    if (!orderedDataCaptures) {
      return;
    }

    if (currentDataCapture) {
      currentDate = DataCaptureSelectorStore.getLocalTimezoneDate(currentDataCapture.capturedAt);

      currentDisplayDate = DataCaptureSelectorStore._formatDate(currentDate);
    }
    else {
      currentDate = null;
      currentDisplayDate = 'No captures available';
    }

    orderedDataCaptures = orderedDataCaptures.sort((a, b) => {

      return new Date(a.capturedAt) - new Date(b.capturedAt);
    });

    orderedDataCaptures.forEach((datacapture) => {

      if (!datacapture.dataCaptureLayers.length) {

        if (availableDataCapturesByType.pc_rgb) {
          availableDataCapturesByType.pc_rgb.push(datacapture);
        }
        else {
          availableDataCapturesByType.pc_rgb = [datacapture];
        }

        if (availableDataCapturesByType.tileLayer) {
          availableDataCapturesByType.tileLayer.push(datacapture);
        }
        else {
          availableDataCapturesByType.tileLayer = [datacapture];
        }
      }
      datacapture.dataCaptureLayers.forEach((datacaptureLayer) => {

        if (availableDataCapturesByType[datacaptureLayer.layerType]) {
          availableDataCapturesByType[datacaptureLayer.layerType].push(datacapture);
        }
        else {
          availableDataCapturesByType[datacaptureLayer.layerType] = [datacapture];
        }
      });
    });


    DataCaptureSelectorStore.setState({
      currentDate,
      currentDisplayDate,
      availableDataCaptures: orderedDataCaptures,
      availableDataCapturesByType
    });

  };

  /**
   * When a date changes it checks for the matching datacap and signals the store
   * for a new datacapture selected
   */
  this._handleDateChanged = (ev) => {

    // TODO FIXME: Since only one dc per date is a soft restriction (there could
    // be cases in the data where that's not true), we need to check only for the
    // first one. Use `_.find` or the method `some` for it.
    DataCaptureSelectorStore.get('availableDataCaptures').forEach((dataCapture) => {

      if (DataCaptureSelectorStore.isSameDate(ev.data.newDate, dataCapture.capturedAt)) {
        DataCaptureSelectorActions.DataCaptureChanged.dispatch({
          newDataCapture: dataCapture
        });
      }
    });
  };

  /**
   * When the user select a datacapture in the list view this function is
   * triggered. Find the datacapture and trigger DatacaptureStore to change the
   * current datacapture.
   *
   * @params {Object} ev
   */
  this._handleDatacaptureSelected = (ev) => {

    const id = ev.data.id;

    const datacaptures = DataCaptureSelectorStore.get('availableDataCaptures');
    const datacapture = datacaptures.find((datacapture) => datacapture.id === id);
    DataCaptureSelectorActions.DataCaptureChanged.dispatch({
      newDataCapture: datacapture
    });
  };

  /**
   * Gets the latest datacapture in the sorted datacapture list, and signals the
   * store.
   */
  this._handleNewestDataCapture = () => {

    const TopControlsStore = Flux.Store.get('TopControlsStore');
    const dataCaptures = DataCaptureSelectorStore.get('availableDataCaptures').reverse();
    const layerType = TopControlsStore.get('currentLayerType');
    let newestDatacapture = null;

    //check for newst datacap with selected layer type 'tileLayer'||'pc_rgb'
    dataCaptures.some((datacapture) => {

      newestDatacapture = datacapture;
      return datacapture.dataCaptureLayers.some((layer) => {

        return layer.layerType === layerType;
      });
    });

    DataCaptureSelectorActions.DataCaptureChanged.dispatch({
      newDataCapture: newestDatacapture
    });
  };

  /**
   * Gets the immediate previous datacapture in the sorted datacapture list, and signals the
   * store.
   */
  this._handlePreviousDataCapture = () => {

    const dataCaptures = DataCaptureSelectorStore.get('availableDataCaptures');
    const datacapture = DataCaptureStore.get('current');
    const index = dataCaptures.findIndex((dc) => dc.id === datacapture.id);
    if (index > 0) {
      DataCaptureSelectorActions.DataCaptureChanged.dispatch({
        newDataCapture: dataCaptures[index - 1]
      });
    }
  };

  /**
   * Gets the immediate next datacapture in the sorted datacapture list, and signals the
   * store.
   */
  this._handleNextDatacapture = () => {

    const dataCaptures = DataCaptureSelectorStore.get('availableDataCaptures');
    const datacapture = DataCaptureStore.get('current');
    const index = dataCaptures.findIndex((dc) => dc.id === datacapture.id);
    if (0 <= index && index < (dataCaptures.length - 1)) {
      DataCaptureSelectorActions.DataCaptureChanged.dispatch({
        newDataCapture: dataCaptures[index + 1]
      });
    }
  };

  // Faster than using momentjs
  DataCaptureSelectorStore.getLocalDateString = (date) => {

    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const formattedDate = [
      year,
      month < 10 ? '0' + month : month,
      day < 10 ? '0' + day : day
    ].join('-');
    return formattedDate;
  };

  /**
   * This function shifts a date (obtaining its utc value) into the local timezone
   * of the current site (based on site location), so it is treated as local
   * e.g. if the browser timezone is GMT -5, and the site timezone is GMT -8, it
   * will apply a -3 hrs difference to adjust the dates
   */
  DataCaptureSelectorStore.getLocalTimezoneDate = (date) => {

    const timezoneOffset = DataCaptureStore.get('timezoneOffset');

    if (typeof date !== 'object') {
      date = new Date(date);
    }

    let result;

    if (timezoneOffset) {

      /* Code explanation */
      // Shift the local time by the difference between the local (browser) time,
      // and the timezone from the site's location. This is to treat the site
      // timestamps in the local browser timezone to be compatible with the
      // date picker operations.
      // LOCAL_TIMEZONE_OFFSET sign is negated (see Date#getTimezoneOffset) so
      // it is added instead of substracted
      const totalOffset = timezoneOffset + LOCAL_TIMEZONE_OFFSET;

      result = new Date(date.getTime() + (totalOffset * 60 * 1000));
    }
    else {
      result = date;
    }

    return new Date(DataCaptureSelectorStore.getLocalDateString(result));
  };

  //binds to store changes
  DataCaptureStore.on(DataCaptureStore.Events.Changed, this._handleDataCaptureStoreChage.bind(this));

  return DataCaptureSelectorStore;
};

DataCaptureSelectorStore.$inject = ['sbFlux', 'DataCaptureSelectorActions', 'APP_DISPATCHER_ID', '$rootScope'];
module.exports = DataCaptureSelectorStore;



// WEBPACK FOOTER //
// ./src/app/dash/topControls/dataCaptureSelector/DataCaptureSelectorStore.js